import KeyValuePair from '@/modules/core/support/KeyValuePair';
import moment from 'moment';



export enum LogLevel {
    EMERGENCY = 'emergency',
    ALERT     = 'alert',
    CRITICAL  = 'critical',
    ERROR     = 'error',
    WARNING   = 'warning',
    NOTICE    = 'notice',
    INFO      = 'info',
    DEBUG     = 'debug',
}

export enum ActionTypes {
    FileAccess = 'FILE_ACCESS',
}

export interface LogContext {
    actionType: ActionTypes,
    file: string
    session: string
    user: string,
    releaseId: number
    releaseVersion: string
}

/**
 * Evento producido en el sistema, relacionado con una distribución
 * registrada en el enrutador
 */
export default class ReleaseLog {
    public id = ''
    public level = 200
    public channel = ''
    public levelName = LogLevel.INFO
    public message = ''
    public datetime = new Date()
    public context: Partial<LogContext> = {}

    /**
     * Crea una entidad a partir de los datos obtenidos de la API
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const log = Object.assign(new this(), data)
        log.datetime = moment(data.datetime, 'DD-MM-YYYY HH:mm:ss').toDate()

        return log
    }
}
